<div class="snackbar-wrap" *ngIf="sanckbarData">
  <div class="snack-inner"  (click)="showLoader? '':sanckbarData.navigation()">
    <div class="snack-left">
      <div class="snack-ico">
        <ng-lottie [options]="snackbarIcon"></ng-lottie>
        <img [src]="icon" alt="School Fees"/>
      </div>
      <div class="snack-content">
        <div class="snack-title">{{title}}</div>
        <div class="snack-info" *ngIf="showLoader">Loading status...</div>
        <marquee class="snack-info" *ngIf=" !showLoader && isTextOverflowed(data)">{{sanckbarData.message}}</marquee>
        <div class="snack-info" *ngIf="!showLoader && !isTextOverflowed(data)">{{sanckbarData.message}}</div>
        <div class="snack-info" #data style="opacity: 0; position: absolute;" >{{sanckbarData.message}}</div>
      </div>
    </div>
    <div class="snack-right">
      <ng-lottie [options]="snackbarArrow"></ng-lottie>      
    </div>
  </div>
</div>